import React from "react";
import EvaluateTable from "./EvaluateTable";
import styled from "styled-components";

const TabContainer = styled.div`
  margin-top: 12px;
`;

const EvaluateTab = ({ totalMarks, action, ...props }: any) => {
  return (
    <TabContainer>
      <EvaluateTable totalMarks={totalMarks} action={action} {...props} />
    </TabContainer>
  );
};

export default EvaluateTab;
